export const ARTS_LIMIT_UPSELL_STEPS = {
  READY: 'ready',
  BONUS: 'bonus',
  SMALLER: 'smaller',
  EXIT: 'exit',
  SUCCESS_PACKAGE: 'success_package',
  SUCCESS_BONUS: 'success_bonus',
  SUCCESS_SMALLER: 'success_smaller',
}

export const FEATURED_PACKAGE = {
  artsCount: 25,
}

export const BONUS_PACKAGE = {
  packageArts: 25,
  bonusArts: 10,
  totalArts: 35,
}

export const ARTS_LIMIT_BONUS_OFFER_CODE = 'arts_limit_bonus'

export const BONUS_OFFER = {
  description: 'Pacote de 25 artes + 10 de bônus',
  price: 'R$ 119',
  timerSeconds: 900,
}

export const SMALLER_OFFER = {
  couponCode: 'PRIMEIRA20',
  couponText: 'Cupom PRIMEIRA20 · válido só na 1ª compra',
  originalPrice: 'R$ 49',
  price: 'R$ 39',
  timerSeconds: 900,
}

export const SMALLER_PACKAGE = {
  artsCount: 10,
}

export const ARTS_LIMIT_PACKAGE_OPTIONS = [
  { id: '10', label: '10 artes', price: 'R$ 49' },
  { id: '50', label: '50 artes', price: 'R$ 249' },
  { id: '100', label: '100 artes', price: 'R$ 499' },
]
